import classNames from 'classnames';
import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
export interface INavLinkProps extends React.HTMLAttributes<HTMLElement> {
  disabled?: boolean;
  route: string;
  name: string;
  notificationCount?: number;
  target?: string;
}

function isLargeCount(notificationCount: number | undefined) {
  if (!notificationCount) return false;
  return notificationCount > 99;
}

export const NavBarLink = (props: INavLinkProps) => {
  const { name, route, notificationCount, ...remainingProps } = props;
  const location = useLocation();
  const isActive = location.pathname?.toLowerCase().startsWith(props.route);
  const isLargeNotificationCount = isLargeCount(notificationCount);

  return (
    <Nav.Item className="position-relative">
      <Nav.Link
        {...remainingProps}
        eventKey="1"
        as={Link}
        to={route}
        active={isActive}
        target={props.target ?? ''}
      >
        <span className="nav-item-title-wrapper">
          <span className="nav-item-title">{name}</span>
          {Boolean(notificationCount) && (
            <span
              className={classNames({
                'notification-badge': true,
                isLarge: isLargeNotificationCount,
              })}
            >
              <span className="notification-badge-value">
                {notificationCount}
              </span>
            </span>
          )}
        </span>
      </Nav.Link>
    </Nav.Item>
  );
};

export const NavBarLinkWithHref = (props: INavLinkProps) => {
  const { name, route, notificationCount } = props;
  const isLargeNotificationCount = isLargeCount(notificationCount);
  return (
    <Nav.Item className="position-relative">
      <Nav.Link href={route}>
        <span className="nav-item-title-wrapper">
          <span className="nav-item-title">{name}</span>
          {Boolean(notificationCount) && (
            <span
              className={classNames({
                'notification-badge': true,
                isLarge: isLargeNotificationCount,
              })}
            >
              <span className="notification-badge-value">
                {notificationCount}
              </span>
            </span>
          )}
        </span>
      </Nav.Link>
    </Nav.Item>
  );
};

export default NavBarLink;
